export const READ_BROWSER_CONTEXT = 'READ_BROWSER_CONTEXT';
export const READ_REQUEST_CONTEXT = 'READ_REQUEST_CONTEXT';
